<template>
  <span class="pi-state-legend">
    <span class="pi-state-legend__text">{{ label }}</span>
    <pi-definition-tooltip :info-key="infoKey" :label="label"/>
  </span>
</template>

<script>
import piDefinitionTooltip from "./piDefinitionTooltip.vue";
import { STATE_LEGEND_INFO_KEY, STATE_LEGEND_LABEL } from "./glossary/index.js";

export default {
  name: "pi-state-legend",
  components: { piDefinitionTooltip },
  data() {
    return { infoKey: STATE_LEGEND_INFO_KEY, label: STATE_LEGEND_LABEL };
  },
};
</script>

<style scoped>
.pi-state-legend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #4e5560;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piStateLegend.vue